const toFinish = promise => promise
  .then(data => [null, data])
  .catch(err => [err]);

export default toFinish;



// WEBPACK FOOTER //
// ./src/utils/toFinish.js